export interface IDateFormat {
  mask: string;
  date: string;
  placeholder: string;
}
